import CreateTemplateDialog from './createTemplateDialog.container';

export default CreateTemplateDialog;
